// src/components/SearchBar.jsx
import React from 'react';
import '../styles/SearchBar.css';
import { ReactComponent as IconSearch } from "../assets/icons/icon-search.svg";



const SearchBar = ({ searchQuery, setSearchQuery, setCurrentPage, placeholder , showFilter = false, onFilterClick}) => (
  <div className="search-wrapper">
    {/* Icono lupa */}
    <IconSearch
      className="search-icon"
    />

    {/* Campo texto controlado */}
    <input
      type="text"
      className="search-input"
      placeholder={placeholder}
      value={searchQuery}
      onChange={e => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
      }}
    />

    {/* (Opcional) Abrir filtros avanzados */}
    {showFilter && (
      <button
        className="filter-btn"
        type="button"
        aria-label="Filtros avanzados"
        onClick={onFilterClick}
      >
        <span />
        <span />
        <span />
      </button>
    )}
  </div>
);

export default SearchBar;
